import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: `Withdraw {currencySymbol}`,

  connectWallet: 'Please connect a wallet',
  connectWalletDescription: 'We couldn’t detect a wallet. Connect a wallet to withdraw.',
});
